import React from "react";
import { ArrowUpRightIcon, LinkedinIcon, InstagramIcon, MailIcon } from "lucide-react";
import { Eyebrow } from "./Eyebrow";
import { PillButton } from "./PillButton";
import { images } from "../data/images";
const socials = [{
  label: "LinkedIn",
  icon: LinkedinIcon,
  href: "#"
}, {
  label: "Instagram",
  icon: InstagramIcon,
  href: "#"
}, {
  label: "Email",
  icon: MailIcon,
  href: "mailto:hello@northgatelegal.co.uk"
}];
export function About() {
  return <section id="about" className="w-full bg-white px-6 py-[120px] lg:px-20" data-id="element-1" data-mp="33pf7tulujjku">
      <div className="mx-auto grid max-w-page grid-cols-12 gap-6" data-id="element-2" data-mp="38oi5uv3espjb">
        <div data-reveal className="col-span-12 md:col-span-4 lg:col-span-3 lg:col-start-2" data-id="element-3" data-mp="3di48dufuzd1e">
          <Eyebrow data-id="element-4" data-mp="3hiwkcvg47w1d">About Northgate</Eyebrow>
          <img src={images.about} alt="A solicitor writing notes at a desk beside a large window" className="mt-6 aspect-[4/3] w-full rounded-xl object-cover" data-id="element-5" data-mp="3hkr1rzs6h60p" />
          <ul className="mt-5 flex items-center gap-4" data-id="element-6" data-mp="3rehnwy0u14d8">
            {socials.map(s => <li key={s.label} data-id="element-7" data-mp="2lp4hysjceujz">
                <a href={s.href} aria-label={s.label} className="text-ink/70 transition-colors duration-150 hover:text-accent" data-id="element-8" data-mp="2grmidsr7tron">
                  <s.icon className="h-4 w-4" strokeWidth={1.75} data-id="element-9" data-mp="2crc13jxz3euh" />
                </a>
              </li>)}
          </ul>
        </div>

        <div data-reveal data-reveal-delay="1" className="col-span-12 md:col-span-8 lg:col-span-7 lg:col-start-6" data-id="element-10" data-mp="27tskiddsypzd">
          <p className="text-[32px] font-medium leading-[1.2] tracking-[-0.035em] text-ink lg:text-[44px]" data-id="element-11" data-mp="30gdfdnthlk7o">
            Northgate Legal started with a simple goal: give businesses and individuals legal advice
            they can actually act on.{" "}
            <span className="text-stone" data-id="element-12" data-mp="2qpsfzy5zobnp">
              Fifteen years later, we’re still doing exactly that — from commercial agreements in the
              City to property disputes across London.
            </span>
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-7" data-id="element-13" data-mp="65u0ap2lusk5">
            <PillButton href="#contact" data-id="element-14" data-mp="66lwa1046say">Book a Consultation</PillButton>
            <a href="tel:+442000000000" className="group inline-flex items-center gap-1.5 border-b border-ink/40 pb-0.5 text-[14px] font-semibold text-ink transition-colors duration-200 hover:border-accent" data-id="element-15" data-mp="b3vjrb3y0tw5">
              Call us now
              <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={2} data-id="element-16" data-mp="3jk74p9v3bpw7" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}